module.exports = __webpack_public_path__ + "static/media/cms-home-icon.9dd147cb.svg";